module.exports = __webpack_public_path__ + "static/media/icons_grey_flip-left.7e2b7d96.svg";